import { Radio, RadioGroup } from "@ttc3k/trekker";
import { ListFilters, ListFilterScreenProps } from "./useFilters";
import { useTranslation } from "react-i18next";

export const VisibilityFilter = ({
  filters,
  onUpdateFilters,
}: ListFilterScreenProps) => {
  const { t } = useTranslation();

  const formattedVisibilityData = Object.values(["LIVE", "UNPUBLISHED"]).map(
    (visibility) => ({
      label: t(`core:LOOKUPS.PUBLICATION_STATUS.${visibility}`),
      value: visibility,
    }),
  );

  const selectedVisibility = filters.visibility;

  const handleVisibilitySelect = (visibility: ListFilters["visibility"]) => {
    onUpdateFilters({
      visibility,
    });
  };
  return (
    <RadioGroup
      value={selectedVisibility}
      onValueChange={({ value }: { value: string }) =>
        handleVisibilitySelect(value as ListFilters["visibility"])
      }
    >
      {formattedVisibilityData.map((o) => {
        return (
          <Radio key={o.value} value={o.value}>
            {o.label}
          </Radio>
        );
      })}
    </RadioGroup>
  );
};
